import script from "./SkeletonhomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonhomeView.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonhomeView.vue?vue&type=style&index=0&id=8c8cd898&lang=css"

const __exports__ = script;

export default __exports__